import { FC, useEffect } from 'react';
import { CallIntelTypes } from '@frontend/api-call-intel';
import { useTimePeriodPopoverSelector } from '@frontend/analytics-shared';
import { trackingIds } from '../../../../../tracking-ids';
import { CALL_INTEL_TIME_PERIODS, DEFAULT_CALL_INTEL_TIME_PERIOD } from '../../../constants';
import { useCallIntelFiltersContext } from '../../context/call-intel-filters.context';
import { getOfficeHoursDateValidation } from '../../utils';
import { useTimePeriodFilterData } from './use-time-period-filter-data';

export const TimePeriodFilterChip: FC<{ disabled?: boolean }> = ({ disabled }) => {
  const { filterValues, filterHintText, isLoading, totalLocationsCount, updateFilterValues, setAutoResetFilters } =
    useTimePeriodFilterData();
  const { setFilterHintText } = useCallIntelFiltersContext();

  useEffect(() => {
    setFilterHintText(filterHintText);
  }, [filterHintText, setFilterHintText]);

  const { TimePeriodPopoverSelector } = useTimePeriodPopoverSelector({
    defaultPeriod: DEFAULT_CALL_INTEL_TIME_PERIOD,
    skipFindingExistingPeriod: true,
    timePeriods: CALL_INTEL_TIME_PERIODS,
    values: {
      endDate: filterValues.endDate,
      selectedPeriod: filterValues.selectedTimePeriodKey,
      startDate: filterValues.startDate,
    },
  });

  return (
    <div data-testid='time-period-filter-chip'>
      <TimePeriodPopoverSelector
        customTimePeriodTracking={{
          filteredLocations: JSON.stringify(filterValues.locations ?? []),
          filteredLocationsCount: filterValues.locations?.length ?? 0,
          selectedLocationIds: JSON.stringify(filterValues.locations),
          totalLocationsCount: totalLocationsCount,
        }}
        disabled={disabled || isLoading}
        onChange={({ startDate, endDate, selectedPeriod }) => {
          const { isValid } = getOfficeHoursDateValidation(startDate, endDate);
          const shouldResetOfficeHours = !!filterValues.officeHours?.length && !isValid;

          updateFilterValues({
            endDate,
            startDate,
            selectedTimePeriodKey: selectedPeriod as CallIntelTypes.SelectedTimePeriodKey,
            ...(shouldResetOfficeHours && { officeHours: [] }),
          });

          if (shouldResetOfficeHours) {
            setAutoResetFilters({ officeHours: true });
          }
        }}
        persistDefaultLabel
        trackingIdBase={trackingIds.callIntel.timeFilter}
      />
    </div>
  );
};
